import { ResetPasswordPage } from './reset-password.page';

export const PAGES = [ResetPasswordPage];

export {
  ResetPasswordPage
};



// WEBPACK FOOTER //
// /azp/_work/1/s/src/app/auth/pages/index.ts